export const CATEGORY_THUMBNAILS: Record<string, { light: string; dark: string }> = {
    phones: {
        light: '/assets/category-thumbnails/telefon.light.webp',
        dark: '/assets/category-thumbnails/telefon.dark.webp'
    },
    tablets: {
        light: '/assets/category-thumbnails/tablet.light.webp',
        dark: '/assets/category-thumbnails/tablet.dark.webp'
    },
    computers: {
        light: '/assets/category-thumbnails/bilgisayar.light.webp',
        dark: '/assets/category-thumbnails/bilgisayar.dark.webp'
    },
    gaming: {
        light: '/assets/category-thumbnails/konsol.light.webp',
        dark: '/assets/category-thumbnails/konsol.dark.webp'
    },
    av_systems: {
        light: '/assets/category-thumbnails/görüntüsessistemleri.light.webp',
        dark: '/assets/category-thumbnails/görüntüsistemleri.dark.webp'
    },
    cars: {
        light: '/assets/category-thumbnails/araba.light.webp',
        dark: '/assets/category-thumbnails/araba.dark.webp'
    },
    motorcycles: {
        light: '/assets/category-thumbnails/motor.light.webp',
        dark: '/assets/category-thumbnails/motor.dark.webp'
    },
    womens_clothing: {
        light: '/assets/category-thumbnails/kadıngiyim.light.webp',
        dark: '/assets/category-thumbnails/kadın.dark.webp'
    },
    mens_clothing: {
        light: '/assets/category-thumbnails/erkekgiyim.light.webp',
        dark: '/assets/category-thumbnails/erkek.dark.webp'
    },
    shoes: {
        light: '/assets/category-thumbnails/ayakkabı.light.webp',
        dark: '/assets/category-thumbnails/ayakkabı.dark.webp'
    },
    bags_accessories: {
        light: '/assets/category-thumbnails/çanta.light.webp',
        dark: '/assets/category-thumbnails/çanta.dark.webp'
    },
    instruments: {
        light: '/assets/category-thumbnails/müzik.light.webp',
        dark: '/assets/category-thumbnails/müzik.dark.webp'
    },
    antiques_collections: {
        light: '/assets/category-thumbnails/antika.light.webp',
        dark: '/assets/category-thumbnails/antik.dark.webp'
    },
    residential: {
        light: '/assets/category-thumbnails/ev.light.webp',
        dark: '/assets/category-thumbnails/ev.dark.webp'
    },
    land: {
        light: '/assets/category-thumbnails/arsa.light.webp',
        dark: '/assets/category-thumbnails/arsa.dark.webp'
    },
    commercial: {
        light: '/assets/category-thumbnails/işyeri.light.webp',
        dark: '/assets/category-thumbnails/işyeri.dark.webp'
    },
    furniture: {
        light: '/assets/category-thumbnails/mobilya.light.webp',
        dark: '/assets/category-thumbnails/mobilya.dark.webp'
    },
    home_appliances: {
        light: '/assets/category-thumbnails/beyazeşya.light.webp',
        dark: '/assets/category-thumbnails/beyazeşya.dark.webp'
    },
    home_textile: {
        light: '/assets/category-thumbnails/evtekstili.light.webp',
        dark: '/assets/category-thumbnails/evtekstil.dark.webp'
    },
    kitchenware: {
        light: '/assets/category-thumbnails/mutfak.light.webp',
        dark: '/assets/category-thumbnails/mutfak.dark.webp'
    },
    office_furniture: {
        light: '/assets/category-thumbnails/ofismalzemeleri.light.webp',
        dark: '/assets/category-thumbnails/ofismalzemeleri.dark.webp'
    },
    construction: {
        light: '/assets/category-thumbnails/inşaatmalzemeleri.light.webp',
        dark: '/assets/category-thumbnails/inşaat malzemeleri.dark.webp'
    },
    work_machines: {
        light: '/assets/category-thumbnails/işmakinesi.light.webp',
        dark: '/assets/category-thumbnails/işmakinesi.dark.webp'
    },
    baby_clothing: {
        light: '/assets/category-thumbnails/bebekgiyim.light.webp',
        dark: '/assets/category-thumbnails/bebekkıyafet.dark.webp'
    },
    baby_equipment: {
        light: '/assets/category-thumbnails/bebekmalzemeleri.light.webp',
        dark: '/assets/category-thumbnails/bebekalet.dark.webp'
    },
    sports_gear: {
        light: '/assets/category-thumbnails/spor.light.webp',
        dark: '/assets/category-thumbnails/spor.dark.webp'
    }
};
